// package: proto
// file: simulation.proto

let simulation_pb = require("./simulation_pb");
let grpc = require("@improbable-eng/grpc-web").grpc;

let GrpcSimulationService = (function () {
  function GrpcSimulationService() { }
  GrpcSimulationService.serviceName = "proto.GrpcSimulationService";
  return GrpcSimulationService;
}());

GrpcSimulationService.Loop = {
  methodName: "Loop",
  service: GrpcSimulationService,
  requestStream: false,
  responseStream: true,
  requestType: simulation_pb.LoopReqeust,
  responseType: simulation_pb.LoopResponse
};

GrpcSimulationService.Run = {
  methodName: "Run",
  service: GrpcSimulationService,
  requestStream: false,
  responseStream: true,
  requestType: simulation_pb.RunRequest,
  responseType: simulation_pb.RunResponse
};

GrpcSimulationService.GetSimulationResult = {
  methodName: "GetSimulationResult",
  service: GrpcSimulationService,
  requestStream: false,
  responseStream: true,
  requestType: simulation_pb.RunRequest,
  responseType: simulation_pb.RunResponse
};

exports.GrpcSimulationService = GrpcSimulationService;

function GrpcSimulationServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

GrpcSimulationServiceClient.prototype.loop = function loop(requestMessage, metadata) {
  let listeners = {
    data: [],
    end: [],
    status: []
  };
  let client = grpc.invoke(GrpcSimulationService.Loop, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

GrpcSimulationServiceClient.prototype.run = function run(requestMessage, metadata) {
  let listeners = {
    data: [],
    end: [],
    status: []
  };
  let client = grpc.invoke(GrpcSimulationService.Run, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

GrpcSimulationServiceClient.prototype.getSimulationResult = function getSimulationResult(requestMessage, metadata) {
  let listeners = {
    data: [],
    end: [],
    status: []
  };
  let client = grpc.invoke(GrpcSimulationService.GetSimulationResult, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

exports.GrpcSimulationServiceClient = GrpcSimulationServiceClient;

